import { useState } from 'react'

import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { ESTADO_CLIENTE, FORMATO_VENTA, SUCURSAL_ORIGEN } from 'Constants'
import { interfaces } from 'service/interfaces'

import { CtaClient } from '../../../../Create/Content'

const SearchClient = (props) => {
  const { data, open, handleClose, setData, dataClient } = props

  const createDismissableSnackbar = useCustomSnackbar()

  const BLOQUEADO = ESTADO_CLIENTE.find((e) => e.label === 'BLOQUEADO')?.value
  const INHABILITADO = ESTADO_CLIENTE.find((e) => e.label === 'INHABILITADO')?.value

  const isClientBlockedOrDisabled = (estado) => {
    const value = Number(estado)
    return value === Number(BLOQUEADO) || value === Number(INHABILITADO)
  }

  const getClientStatusMessage = (estado) => {
    const value = Number(estado)
    if (value === Number(BLOQUEADO)) return 'El cliente está bloqueado.'
    if (value === Number(INHABILITADO)) return 'El cliente está inhabilitado.'
    return 'El cliente no está habilitado.'
  }
  const formatoVentaLabel = FORMATO_VENTA.find(
    (f) => f.id === Number(dataClient.formato_venta)
  )?.label

  const [isLoading, setIsLoading] = useState(false)
  const [info, setInfo] = useState({
    empresa: dataClient.origen,
    formato_venta: formatoVentaLabel,
    search: '',
    cuit: '',
    tipo_responsable: null,
    nombre: '',
    cliente_id: null,
    id: null,
    estado: null,
  })

  const handleChange = (name, value) => {
    setInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  function _renderStepContent() {
    return (
      <InputsWithoutValidate
        fields={CtaClient(info, handleSubmitCode, handleChange, isLoading, data)}
        spacing={2}
      />
    )
  }

  async function handleSubmitCode(info) {
    const origenEncontrado = SUCURSAL_ORIGEN.find((sucursal) => sucursal.label === info.empresa)
    const empresaId = origenEncontrado.id
    const values = {
      empresa: empresaId,
      search: info.search,
      pedido: dataClient.id,
    }
    setIsLoading(true)
    await interfaces.salesOrders
      .searchClients(values)
      .then((res) => {
        const clientData = res.data[0]

        if (isClientBlockedOrDisabled(clientData?.estado)) {
          createDismissableSnackbar(getClientStatusMessage(clientData?.estado), {
            variant: 'error',
          })

          setInfo((prev) => ({
            ...prev,
            cuit: '',
            tipo_responsable: null,
            nombre: '',
            cliente_id: null,
            id: null,
            estado: clientData?.estado ?? null,
          }))
          return
        }

        setInfo({
          ...info,
          cuit: clientData.cuit,
          tipo_responsable: clientData.tipo_responsable,
          nombre: clientData.nombre,
          cliente_id: clientData.id,
          id: clientData.id,
          estado: clientData.estado,
          cond_iva: clientData.cond_iva,
          provincia: clientData.provincia,
          localidad: clientData.localidad,
          domicilio: clientData.domicilio,
          saldo: clientData.saldo,
        })
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      })

    setIsLoading(false)
  }

  const updateClient = async () => {
    if (isClientBlockedOrDisabled(info.estado)) {
      createDismissableSnackbar(getClientStatusMessage(info.estado), {
        variant: 'error',
      })
      return
    }
    setIsLoading(true)
    try {
      setData((prevData) => ({
        ...prevData,
        ctaCliente: {
          ...prevData.ctaCliente,
          ...info,
        },
      }))
      setIsLoading(false)
      handleClose()
    } catch (error) {
      setIsLoading(false)
    }
  }

  return (
    <DialogComponent
      title="Buscar cliente"
      open={open}
      handleclose={handleClose}
      handleclosedisabled={isLoading}
      widthLarge="500px"
      disableBackdropClick
      disableEscapeKeyDown
      maxHeight
      children={
        <>
          <div style={{ height: '500px' }}>{_renderStepContent()}</div>
        </>
      }
      actions={
        <CancelConfirmButtons
          disabledSubmit={
            isLoading || isClientBlockedOrDisabled(info.estado) || !info?.cliente_id || !info?.id
          }
          disabledCancel={isLoading}
          isLoading={isLoading}
          onClickSubmit={updateClient}
          onClickCancel={handleClose}
        />
      }
    />
  )
}
export default SearchClient
